import { Modal, Table } from "antd";
import React, { useMemo } from "react";
import { CloseOutlined } from "@ant-design/icons";
import { ChantButton } from "../../../CommonComponents";

const ROLES = [
  { value: "admin", label: "Admin" },
  { value: "member", label: "Member" },
  { value: "ticket-scanner", label: "Ticket Scanner" },
  { value: "capo", label: "Capo" },
  { value: "leader", label: "Leader" },
  { value: "club-admin", label: "Club Admin" },
];

const UpdateRoleModal = ({
  isModalVisible,
  setIsModalVisible,
  isSaving,
  roleChanges,
  removeChange,
  handleSaveChanges,
}) => {
  const columns = useMemo(
    () => [
      {
        title: "Name",
        dataIndex: "userName",
        key: "userName",
        width: 200,
      },
      {
        title: "Group",
        dataIndex: "groupName",
        key: "groupName",
        width: 200,
      },
      {
        title: "Current Role",
        dataIndex: "oldRole",
        key: "oldRole",
        width: 150,
        render: (role) => ROLES.find((r) => r.value === role)?.label || role,
      },
      {
        title: "New Role",
        dataIndex: "newRole",
        key: "newRole",
        width: 150,
        render: (role) => ROLES.find((r) => r.value === role)?.label || role,
      },
      {
        title: "Action",
        key: "action",
        width: 80,
        render: (_, record) =>
          !isSaving && (
            <CloseOutlined
              style={{
                fontSize: 16,
                color: "#999",
                cursor: "pointer",
              }}
              onClick={() => removeChange(record.changeKey)}
            />
          ),
      },
    ],
    [isSaving, removeChange]
  );

  const dataSource = useMemo(
    () =>
      Object.entries(roleChanges).map(([key, change]) => ({
        key,
        ...change,
      })),
    [roleChanges]
  );

  const changeCount = Object.keys(roleChanges).length;

  return (
    <Modal
      title="Confirm Role Changes"
      open={isModalVisible}
      onCancel={() => !isSaving && setIsModalVisible(false)}
      footer={null}
      width={900}
      maskClosable={!isSaving}
    >
      <div>
        <p style={{ marginBottom: 16 }}>
          You are about to update the roles for the following members:
        </p>

        <Table
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          scroll={{ y: 400 }}
        />

        <div
          style={{
            marginTop: 16,
            display: "flex",
            justifyContent: "flex-end",
            gap: 12,
          }}
        >
          <ChantButton
            onClick={() => setIsModalVisible(false)}
            disabled={isSaving}
          >
            Cancel
          </ChantButton>
          <ChantButton
            type="primary"
            onClick={handleSaveChanges}
            loading={isSaving}
            disabled={changeCount === 0}
          >
            Save Changes
          </ChantButton>
        </div>
      </div>
    </Modal>
  );
};

export default UpdateRoleModal;
